import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// Datepicker
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, Form, FormCheckbox, FormInput, Icon, Label, Table } from 'semantic-ui-react';

// Actions
import { setContractData, doContractAction } from "./contractSlice";

// Styles
import './contract.css';


//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode
 * @param {bool} additional
 * @returns 
 */
const Max2ContractHeadOfficeMaxStay = ({ editMode, additional = false }) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const MaxStay = additional ? Contract.MaxStayUS : Contract.MaxStay;

  const { t } = useTranslation();

  // Edit mode?
  const readOnly = editMode ? false : true;
  
  /**
   * only numbers allowed in allotment max 
   * @param {even} e 
   */
  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };



  /**
   * 
   * @param {bool} headoffice 
   */
  const handleAddNewRow = (headoffice = false) => {
    dispatch(doContractAction({target: 'MaxStay.addRow', value: headoffice}))
  }



  /**
   * 
   */
  const handleDeleteRow = (rowIndex) => {
    dispatch(doContractAction({target: 'MaxStay.deleteRow', value: rowIndex}))
  }



  /**
   * 
   */
  const handleCopyRow = (rowIndex) => {
    dispatch(doContractAction({target: 'MaxStay.copyRow', value: rowIndex}))
  }

  // If no records
  if (typeof MaxStay === 'undefined' || !MaxStay || !MaxStay.length) {
    return (
    <> 
    {!readOnly && (
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRowHeadOffice')}
      </Button>
    )}
    </>);
  }

  return (
    <>
    <Table celled structured striped basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.from')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.to')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.monShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.tueShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.wedShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.thuShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.friShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.satShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.sunShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.days')}</Table.HeaderCell>
          {!readOnly && (
            <Table.HeaderCell></Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {MaxStay.map((maxstay, maxstayKey)=>(
          <Table.Row key={maxstayKey}>
            <Table.Cell>
              {!maxstay.Additional && (<Label as='a' color='red' ribbon>{t('settings.userDetails.headOffice')}</Label>)}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(maxstay.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected={maxstay.Start}
                  startDate={maxstay.Start}
                  endDate={maxstay.End}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'MaxStay.Start', row: maxstayKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(maxstay.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected={maxstay.End}
                  startDate={maxstay.Start}
                  endDate={maxstay.End}
                  minDate={maxstay.Start}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(maxstay.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'MaxStay.End', row: maxstayKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.mon ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.mon ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'mon', value: !maxstay.Weekdays.mon }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.tue ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.tue ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'tue', value: !maxstay.Weekdays.tue }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.wed ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.wed ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'wed', value: !maxstay.Weekdays.wed }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.thu ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.thu ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'thu', value: !maxstay.Weekdays.thu }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.fri ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.fri ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'fri', value: !maxstay.Weekdays.fri }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.sat ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.sat ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'sat', value: !maxstay.Weekdays.sat }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{maxstay.Weekdays.sun ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={maxstay.Weekdays.sun ? true : false} onClick={() => dispatch(setContractData({target: 'MaxStay.Weekday', row: maxstayKey,  weekday: 'sun', value: !maxstay.Weekdays.sun }))} />}</Table.Cell>
            <Table.Cell>
              {readOnly ? <>{maxstay.Value}</> : <Form><FormInput type="number" maxLength={2} onKeyPress={handleKeyPress} style={{width: "70px"}} value={maxstay.Value} onChange={(e, data) => dispatch(setContractData({target: 'MaxStay.Value', row: maxstayKey,  value: data.value}))} /></Form>}
            </Table.Cell>
            {!readOnly && (
              <Table.Cell>
                <Button basic circular icon>
                  <Icon name='trash' onClick={() => handleDeleteRow(maxstayKey)} />
                </Button>
                <Button basic circular icon>
                  <Icon name='copy outline' onClick={() => handleCopyRow(maxstayKey)} />
                </Button>
              </Table.Cell>
            )}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    {!readOnly && (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRowHeadOffice')}
      </Button>
      </>
    )}
    </>
  );
}

export default Max2ContractHeadOfficeMaxStay;
